/* SEARCH FILTERS */
import { timeToMinutes } from "../dms-detail/tabs-section/tabs/KeylessInfo";
import { IDmsSearchFilters } from "./models";
import * as yup from "yup";

export const SEARCH_FILTERS_FORM_INITIAL_VALUES: IDmsSearchFilters = {
    name: '',
    identificationCode: '',
    sapId: '',
    dmsType: null,
    dmsCategory: [],
    currentStatus: null,
    currentAttribute: '',
    region: '',
    province: '',
    city: '',
    address: '',
    streetNumber: '',
    serviceType: [],
    chargingStationStatus: null,
    chargingColumnId: '',
    certificationProtocolIdentifyingCode: '',
    companyName: '',
    tenants: null,
    dealers: null,
    isKeyless: undefined

}

// Validation Schema
export const SEARCH_FILTERS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    name: yup.string()
        .nullable(),
    identificationCode: yup.string()
        .nullable(),
    sapId: yup.string()
        .nullable(),
    dmsType: yup.string()
        .nullable(),
    dmsCategory: yup.string()
        .nullable(),
    currentStatus: yup.string()
        .nullable(),
    currentAttribute: yup.string()
        .nullable(),
    region: yup.string()
        .nullable(),
    province: yup.string()
        .nullable(),
    city: yup.string()
        .nullable(),
    address: yup.string()
        .nullable(),
    streetNumber: yup.string()
        .nullable(),
    chargingStationIdentificationCode: yup.string()
        .nullable(),
    chargingStationStatus: yup.string()
        .nullable(),
    chargingColumnId: yup.string()
        .nullable(),
    certificationProtocolIdentifyingCode: yup.string()
        .nullable(),
    companyName: yup.string()
        .nullable()
});

export const DMS_DOCUMENTS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    documents: yup.array().of(yup.object().shape({
        fileName: yup.string().nullable(),
        file: yup.string().nullable().when('fileName', {
            is: (fileName: string | null | undefined) => !fileName,
            then: (schema) => schema.required("Required"),
            otherwise: (schema) => schema.notRequired()
        }),
        title: yup.string().nullable().required("Required"),
        note: yup.string().ensure().when('title', {
            is: 'Other',
            then: yup.string().required("Required field")
        }),
        validityStartDate: yup.date().nullable().when('title', {
            is: (title: string) => {
                if (title === "Contract document") {
                    return true // validate and go to then function
                }
                if (title === "Insurance document") {
                    return true // validate and go to then function
                } else return false // for all other cases studentName is not required
            },
            then: (schema) =>
                schema
                    .required("Required field"),
        }),
        validityEndDate: yup.date().nullable().min(
            yup.ref("validityStartDate"),
            "End date has to be more or equal than start date"
        ).when('title', {
            is: (title: string) => {
                if (title === "Contract document") {
                    return true
                }
                if (title === "Insurance document") {
                    return true
                } else return false
            },
            then: (schema) =>
                schema
                    .required("Required field"),
        }),
        validityAnnualPremiumEndDate: yup.date().nullable().when('title', {
            is: "Insurance document",
            then: yup.date().required("Required field")
        })
    }))

});

export const ADDITIONAL_INFO_FORM_VALIDATION_SCHEMA = yup.object().shape({
    // rcetmaxAssignedVehicle: yup.string().required("Required"),
    // rceMaxPreauth: yup.string().required("Required"),
    rceMaxPreauth: yup
        .string()
        .nullable()
        .test(
            function (value) {
                const { rcetmaxAssignedVehicle } = this.parent;
                if (!value || !rcetmaxAssignedVehicle) return true;
                return timeToMinutes(value) <= timeToMinutes(rcetmaxAssignedVehicle);
            }
        ),
});
